import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/support/supportQueryKeys.ts
var t = e("support", {
	categories: (e) => ["categories", e],
	articles: (e) => ["articles", e],
	article: (e) => ["article", e],
	faqs: (e) => ["faqs", e],
	myTickets: () => ["my-tickets"],
	ticket: (e) => ["ticket", e],
	myCallbacks: () => ["my-callbacks"]
}), n = e("admin-support", {
	tickets: (e) => ["tickets", e],
	ticketStats: () => ["ticket-stats"],
	ticket: (e) => ["ticket", e],
	articles: (e) => ["articles", e],
	article: (e) => ["article", e],
	categories: () => ["categories"],
	faqs: () => ["faqs"],
	callbacks: (e) => ["callbacks", e],
	callbackStats: () => ["callback-stats"]
});
//#endregion
export { n as adminSupportQueryKeys, t as supportQueryKeys };
